<div class="container-fluid routes">
    <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
    </div>
    <!-- <div class="row">
      <div style="margin-top:10px; margin-bottom:-10px;">
        <h5><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Manage {{this.lblHeading}}</b></h5>
      </div>
    </div> -->




    <button id="btnSearch" style="width: 0px; display: none;" (click)="onSearch()" visibility="hidden">
    </button>

    <div class="row" *ngIf="hideHeader">
        <div class="col-md-12">
            <div class="routes-1 opensans-semi-bold-sapphire-30px">
                <span class="opensans-semi-bold-sapphire-30px">Digital Routes</span>
                <span  *ngIf="!isView"  class="opensans-semi-bold-sapphire-24px" style="margin-left: 18px; float: right;"><a (click)="getTextRoutes()" style="cursor: pointer;">Back to Text Routes</a></span>
                <div class="rectangle-210"></div>
                <br/>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-4"  *ngIf="!isView" >
            <form [formGroup]="routeForm">
              <select class="form-control form-control-sm"  id="ListSelectedRoute_id" name="ListSelectedRoute_id"
              formControlName="ListSelectedRoute_id" (change)="onItemChange($event.target.value)">
                  <option value=""  disabled selected>Select a route</option>
              <ng-container *ngIf="routeList">
                  <option *ngFor="let route of routeList" [ngValue]="route.id">{{route.description}}</option>
              </ng-container>
          </select>
            </form>
        </div>  
   <div class="col-md-8" *ngIf="hideHeader">
       <app-filter></app-filter>
       <br/>
       <br/>
   </div>
    </div>

    <div class="row">
        <div *ngIf="selectedRouteId == 0" class="col-md-12">
            <table class="table table-sm table-borderless" style="width:100%">
                <thead>
                <tr>
                    <th  *ngIf="!isView" >
                        Select Route
                    </th>
                    <th class="th-sm" style="text-align: left" style="max-width:120px !important;">
                        Route Name
                    </th>
                    <th class="th-sm" style="max-width:120px !important;">
                        Description
                    </th>
                    <th class="th-sm">
                        Cargo
                    </th>
                    <th>
                        Route Type
                    </th>
                    <th class="bfr-end-col">
                        Stops
                    </th>
                    <th class="bfr-end-col">Est. distance</th>
                    <th class="btn-show hgt-btn bfr-end-col end-col">
                        Est. duration
                    </th>
                    <th class="bfr-end-col"  style="max-width:120px !important;">
                     <center>View Map</center>   
                    </th>
                    
                    <th  *ngIf="!isView" >
                       Customise Route
                    </th>
                </tr>
                </thead>
                <tr  class="selected-route"  *ngIf="selectedRoute !== undefined && selectedRoute !== null">
                    <td>
                        <input
                                type="checkbox"
                                value="{{ selectedRoute.id }}"
                                [ngModel]="selectedRouteId"
                                (change)="selectRoute(selectedRoute)"
                                [disabled]="isAdmin"
                        />
                    </td>
                    <td class="bfr-end-col" style="max-width:120px !important;">{{selectedRoute.description}}</td>
                    <td class="bfr-end-col" style="max-width:120px !important;">{{selectedRoute.route_summary}}</td>
                    <td class="bfr-end-col">{{selectedRoute.freight_passenger_ind}}</td>
                    <td class="bfr-end-col" style="max-width:100px !important;">{{selectedRoute.route_type_ind}}</td>
                    <td class="bfr-end-col">{{selectedRoute.num_border_crossings ? selectedRoute.num_border_crossings : 0}}</td>
                    <td class="bfr-end-col" style="max-width:120px !important;">{{selectedRoute.distance ? selectedRoute.distance : 0}} km</td>
                    <td class="bfr-end-col" style="max-width:120px !important;">{{toHoursAndMinutes(selectedRoute.duration)}}</td>
                    <td class="btn-show bfr-end-col">
                        <!-- TO DO, PASS THE SOURCE AND DESTINATION TO THE MAP-->
                        <app-route-viewer-map mapid="map-selected-route" [title]="selectedRoute.description"   [source]="selectedRoute.source" [destination]="selectedRoute.destination"></app-route-viewer-map>
                    </td>
                    <td class="btn-show bfr-end-col"  *ngIf="!isView" >
                        <!--                        <a (click) =selectRoute(cType)><img-->
                        <!--                                src="../../../assets/newimg/border-color-13@2x.png" title="Select Route"-->
                        <!--                                style="cursor: pointer;margin: 10px;"/></a>-->

                        <a  (click)="selectRoute(selectedRoute)"><img src="../../../assets/newimg/border-color-61@2x.png" title="Select Route"
                                                                                              style="cursor: pointer;margin: 10px;"/></a>
                        <!--                        <img src="../../../../../assets/newimg/delete-30@2x.png" title="Delete Route"-->
                        <!--                             (click)="onConfirm(cType.id)" style="cursor: pointer;"/>-->
                    </td>
                </tr>
                <ng-container *ngIf="routes.length > 0">
                <tr [ngClass]="{'selected-route' : (selectedRoute !== undefined && cType === selectedRoute)}"
                    *ngFor="let cType of routes   | orderBy:  [ utility.criteria, 'sort_order', 'group_code', 'code', 'description', 'is_active' ] : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }; let i = index">
                    <td>
                        <input
                                type="checkbox"
                                value="{{ cType.id }}"
                                [ngModel]="selectedRouteId"
                                (change)="selectRouteToApplication(cType)"
                                [disabled]="isAdmin"
                        />
                    </td>
                    <td class="bfr-end-col" style="max-width:120px !important;">{{cType.description}}</td>
                    <td class="bfr-end-col" style="max-width:120px !important;">{{cType.route_summary}}</td>
                    <td class="bfr-end-col">{{cType.freight_passenger_ind}}</td>
                    <td class="bfr-end-col" style="max-width:100px !important;">{{cType.route_type_ind}}</td>
                    <td class="bfr-end-col">{{cType.num_border_crossings ? cType.num_border_crossings : 0}}</td>
                    <td class="bfr-end-col" style="max-width:120px !important;">{{cType.distance ? cType.distance : 0}} km</td>
                    <td class="bfr-end-col" style="max-width:120px !important;">{{toHoursAndMinutes(cType.duration)}}</td>
                    <td class="btn-show bfr-end-col">
                        <!-- <button
                        type="button"
                        data-toggle="modal"
                        data-target="#RouteMap"
                        class="btn_icon"
                        aria-label="View Map">
                        <img style="cursor: pointer;margin: 10px;" src="assets/visibility.png" alt="View Route Map" />
                        </button> -->

<!--                        TO DO, PASS THE SOURCE AND DESTINATION TO THE MAP-->
                        <app-route-viewer-map  [mapid]="'map-' + i" [title]="cType.description"   [source]="cType.source" [destination]="cType.destination"></app-route-viewer-map>
                    </td>
                    <td class="btn-show bfr-end-col"  *ngIf="!isView" >

                        <a *ngIf="cType !== selectedRoute" (click)="selectRoute(cType)"><img src="../../../assets/newimg/border-color-13@2x.png" title="Customise Route"
                                style="cursor: pointer;margin: 10px;"/></a>
                        <a  *ngIf="cType === selectedRoute" (click)="selectRoute(cType)"><img src="../../../assets/newimg/border-color-61@2x.png" title="Customise Route"
                                                             style="cursor: pointer;margin: 10px;"/></a>
                    </td>
                </tr>
                </ng-container>
                <tfoot>
                <tr *ngIf="routes.length > 4" style="padding-left:0px;margin-left:0px;">
                    <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
                        <div class="row">
                            <div class="col-2">
                                <div class="input-group mb-3 rm-brd"
                                     style="width:125px!important;height:30px!important;">
                                    <div class="input-group-prepend">
                                        <label class="input-group-text form-control-sm show-h"
                                               for="show-id">Show:</label>
                                    </div>
                                    <select class="form-control form-control-sm show-h" id="show-id"
                                            [(ngModel)]="showNum">
                                        <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-8 text-center">
                                <pagination-controls (pageChange)="utility.page = $event"
                                                     style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                            </div>
                        </div>
                    </td>

                </tr>

                <tr *ngIf="isEmpty && !isView" >
                    <td colspan="8" class="rm-brd">
                        <span class="text-info text-small">Please select a route from the dropdown or chose different parameters on the filter to get more routes.</span>
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <div class="text-center">
    <button title="Cancel" *ngIf="!isView" (click)="cancelApplication()"   type="submit" class="btn hd-btn-close">
        Close
    </button>
    <button *ngIf="!isView"  (click) ="goBack()"  type="submit" class="btn  hd-btn">
        Back
    </button>
    <button *ngIf="!isView"  (click)="savedSelectedRoute()" type="submit" class="btn  hd-btn">
        Next
    </button>
    </div>
</div>
